document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.loaf-order-picker[open]').forEach(picker => {
    picker.open = false;
    picker.querySelector('summary').focus();
  });
});
document.addEventListener('click', event => {
  document.querySelectorAll('.loaf-order-picker[open]').forEach(picker => {
    if (!picker.contains(event.target)) picker.open = false;
  });
});

// Appended to the existing navigation asset to avoid an additional script request.
(() => {
  if (window.loafologyActionsInitialised) return;
  window.loafologyActionsInitialised = true;

  const branchPaths = {
    '/pages/loafology-blue-area-islamabad': 'blue',
    '/pages/loafology-f11-islamabad': 'f11',
    '/pages/loafology-diplomatic-enclave-islamabad': 'diplomatic',
    '/pages/loafology-gold-crest-mall-lahore': 'gold',
    '/pages/loafology-gulberg-lahore': 'gulberg'
  };
  const orderPaths = {
    '/pages/blue-area-and-lahore': '',
    '/pages/diplomatic': 'diplomatic',
    '/pages/lahore-dha-goldcrest-branch': 'gold'
  };
  const branchIds = ['blue', 'f11', 'diplomatic', 'gold', 'gulberg'];
  const cleanPath = path => path.replace(/\/$/, '') || '/';

  function branchContext(element) {
    const card = element.closest('[data-home-branch]');
    if (card && branchIds.includes(card.dataset.homeBranch)) return card.dataset.homeBranch;
    const selector = element.closest('[data-loafology-menu]')?.querySelector('[data-menu-branch-select]');
    if (selector && branchIds.includes(selector.value)) return selector.value;
    return element.closest('.loaf-branch') ? branchPaths[cleanPath(location.pathname)] || '' : '';
  }

  function sourceArea(element) {
    if (element.closest('#SiteHeader, #NavDrawer')) return 'navigation';
    if (element.closest('footer, #Footer')) return 'footer';
    if (element.closest('.loaf-branch')) return 'branch_page';
    if (element.closest('[data-loafology-menu]')) return 'html_menu';
    if (element.closest('.loaf-home-location, .loaf-home-hero')) return 'homepage';
    return 'content';
  }

  function emit(name, detail) {
    const parameters = Object.assign({ page_path: location.pathname }, detail);
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, parameters);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: name }, parameters));
      }
    } catch (_) {
      // Analytics availability must never interrupt a customer action.
    }
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const summary = event.target.closest('.loaf-order-picker > summary');
    if (summary) {
      if (!summary.parentElement.open) emit('order_picker_open', { link_area: 'navigation' });
      return;
    }
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('data-brand-link')) return;
    const detail = { link_area: sourceArea(link) };
    const contextBranch = branchContext(link);
    if (contextBranch) detail.branch_id = contextBranch;
    if (link.hasAttribute('data-loaf-home-order')) {
      emit('order_picker_open', detail);
      return;
    }
    let url;
    try { url = new URL(link.href, location.origin); } catch (_) { return; }
    if (url.protocol === 'tel:') {
      emit('click_to_call', detail);
      return;
    }
    if (['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname)) {
      emit('whatsapp_click', detail);
      return;
    }
    if (['maps.google.com', 'maps.app.goo.gl', 'goo.gl'].includes(url.hostname) ||
        (['google.com', 'www.google.com'].includes(url.hostname) && url.pathname.startsWith('/maps'))) {
      emit('get_directions', detail);
      return;
    }
    if (url.pathname.toLowerCase().endsWith('.pdf') && link.closest('[data-loafology-menu]')) {
      emit('menu_pdf_download', detail);
      return;
    }
    if (url.origin !== location.origin) return;
    const path = cleanPath(url.pathname);
    detail.destination_path = path;
    if (branchPaths[path]) {
      detail.branch_id = branchPaths[path];
      emit('view_branch', detail);
    } else if (Object.prototype.hasOwnProperty.call(orderPaths, path)) {
      const branch = contextBranch || orderPaths[path];
      if (branch) detail.branch_id = branch;
      emit('order_now_click', detail);
    } else if (path === '/pages/our-menu') {
      emit('menu_open', detail);
    } else if (path === '/pages/locations' || path === '/pages/branches') {
      emit('branch_directory_open', detail);
    }
  }, true);

  document.addEventListener('change', event => {
    const selector = event.target;
    if (!(selector instanceof HTMLSelectElement) || !selector.matches('[data-menu-branch-select]')) return;
    if (branchIds.includes(selector.value)) emit('menu_branch_select', { branch_id: selector.value, link_area: 'html_menu' });
  });
})();
